"use client";

import { HeadingLevel } from "@ariakit/react";
import cn from "clsx";
import Link from "next/link";

import type { ReactNode } from "react";
import type {
  FeedItemVignette,
  FeedItemVignetteLink,
} from "../../../../types/content/feedItemVignette";

import { getSlugFromTitle } from "../../../../utils/getSlugFromTitle";
import styles from "./TeaserClusterVignette.module.scss";

const LinkHandler = ({
  children,
  link,
  entityTitle,
}: {
  link: FeedItemVignetteLink;
  entityTitle: string;
  children: ReactNode;
}) => {
  if (!link) {
    return <>{children}</>;
  }

  const isCategory = link.entityType === "category";

  const titleSlug = getSlugFromTitle(entityTitle);
  const url = isCategory
    ? `/${link.entityId}`
    : `/t/${titleSlug}/${link.entityId}`;

  return (
    <Link href={url} prefetch={false}>
      {children}
    </Link>
  );
};

const TeaserClusterVignette = ({
  resource,
  isNative,
  isPremium,
}: {
  resource: FeedItemVignette;
  isNative?: boolean;
  isPremium?: boolean;
  isLoggedIn?: boolean;
  articleId?: string;
}) => {
  const secondaryVignette = resource?.secondaryVignette;
  const primaryVignette = resource.primaryVignette;
  const link = resource?.link;

  return (
    <div className={cn([styles.feedItemVignette, isNative && styles.native])}>
      <LinkHandler link={link} entityTitle={primaryVignette}>
        <HeadingLevel>
          <span
            className={cn([
              styles.titleLink,
              isNative && styles.native,
              isPremium && styles.premium,
            ])}
          >
            {isNative ? secondaryVignette : primaryVignette}
          </span>
          {secondaryVignette && (
            <>
              <span className={cn([styles.prefix, isNative && styles.native])}>
                {" "}
                •{" "}
              </span>
              <span
                className={cn([
                  styles.suffix,
                  styles.titleLink,
                  styles.uncoloredLink,
                  isPremium && styles.premium,
                ])}
              >
                {isNative ? primaryVignette : secondaryVignette}
              </span>
            </>
          )}
        </HeadingLevel>
      </LinkHandler>
    </div>
  );
};

export { TeaserClusterVignette };
